import { Icon } from '@livable/saas-react-components';
import { Button, Typography } from '@mui/material';
import { track, events } from 'src/configs/amplitude';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SplitPageContainer from 'src/components/shared/SplitPageContainer';
import LoginLeftContent from 'src/components/shared/LoginLeftContent';
import { Link as RouterLink } from 'react-router-dom';
import sentSvg from 'src/img/sent.svg';
import useStyles from './styles';
export default function ResetPasswordRequestPage() {
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const page = 'Reset Password Request';
  return /*#__PURE__*/React.createElement(SplitPageContainer, {
    imageScr: sentSvg,
    leftBlock: /*#__PURE__*/React.createElement(LoginLeftContent, null),
    largeTopMargin: true
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.pageForm
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.resetPageSuccessIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "success"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    marginBottom: "40px"
  }, t('log_in_flow.reset_request_sent')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p",
    marginBottom: "40px"
  }, t('log_in_flow.we_sent_instructions')), /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    variant: "text",
    to: "/login",
    onClick: () => track(events.clicked('Back To Login'), {
      page
    }),
    fullWidth: true,
    'custom-attribute': '800-reset-password-req-page'
  }, t('buttons.back_to_login'))));
}
ResetPasswordRequestPage.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string
  })
};